// extracted by mini-css-extract-plugin
module.exports = {"progressSlider":"TimelinePrograssBar_progressSlider__mgPUh","durationMillis":"TimelinePrograssBar_durationMillis__tkB1Q"};